/**
 * 功能： 预售；
 * 注意： 预售分两种： a:普通预售 b: 候补销售
 * presellType: 0 普通预售； 1 候补销售
 * 注： 候补销售等价于全款预售
 */

import Promotion from "@core/Promotion.js";
import {$date, $util} from "@util/util.js";

// 预售类型  普通预售：0  候补：1
const PRESELLTYPE = {
    NORMAL: 0,
    ALTERNATE: 1
}

export default class Booking extends Promotion{
    constructor(){
        super();
        this._leftTime = "";
        this._desc = "";
        this._lastDesc = "";
        // this._currentTime = _engine._currentTime;
    }

    renderPreSellText(presellType = {}) {
        if(presellType == PRESELLTYPE.ALTERNATE) {
            return "候补";
        }else {
            return "预售活动";
        }
    }
    //活动即将开始，尽情期待：presellStartTime 不存在值
    //距预售开始：presellStartTime - current
    //距定金支付结束：depositEndTime - current
    //距预售活动结束：presellEndTime - current
    init(data){
        this._name = data.presellType == PRESELLTYPE.ALTERNATE ? "候补" : "预售";
        this.presellType = data.presellType;
        this._salesType = data.salesType;
        this._presellway = data.presellway;//1全款，2定金
        this._deposit = data.deposit && data.deposit.showAmount;//全款或者定金金额
        this._deduction = data.deduction && data.deduction.showAmount;//抵扣金额
        this._restPayment = data.restPayment && data.restPayment.showAmount;//尾款金额
        this._depositStartTime = data.depositStartTime;//定金支付开始时间
        this._depositEndTime = data.depositEndTime; //定金支付结束时间        
        this._tailPaymentDay = data.tailPaymentDay;
        this._tailDeliveryDay = data.tailDeliveryDay;//尾款支付时间
        this._presellStartTime = data.presellStartTime;
        this._presellEndTime = data.presellEndTime;
        this._tailTime = data.tailTime;

        this.tick();
    }

    //1：活动即将开始，尽情期待
    //2：距预售开始
    //3：距定金支付开始
    //4：距定金支付结束 == 5：距预售活动结束
    
    getTimeQuantum(){
        if(!this._presellStartTime){
            return 1;
        }
        if($date.compareData(this._presellStartTime, this._currentTime)){
            return 2;
        }
        if($date.compareData(this._currentTime, this._presellStartTime) && $date.compareData(this._depositStartTime, this._currentTime)){
            return 3;
        }
        // if($date.compareData(this._currentTime, this._depositStartTime) && $date.compareData(this._depositEndTime, this._currentTime)){
        //     return 4;
        // }
        if($date.compareData(this._depositEndTime, this._currentTime) && $date.compareData(this._presellEndTime, this._currentTime)){
            return 4;
        }
    }

    getLeftInfo(){
        //任意一个时间相等都刷新页面，重置所有
        if(this._presellStartTime  && $date.equalTime(this._currentTime, this._presellStartTime)){
            window.location.href = window.location.href;
        }
        if(this._depositStartTime && $date.equalTime(this._currentTime, this._depositStartTime)){
            window.location.href = window.location.href;
        }
        // 尾款公布时间 需要刷新一下页面
        if(this._tailTime &&  $date.equalTime(this._currentTime, this._tailTime)){
            window.location.href = window.location.href;
        }
        if(this._presellEndTime && $date.equalTime(this._currentTime, this._presellEndTime)){
            window.location.href = window.location.href;
        }
        let flag = this.getTimeQuantum();
        if(flag == 1){
            this._desc = '活动即将开始，敬请期待…';
            this._leftTime = '';
        }
        if(flag == 2){
            this._desc = `距${this.renderPreSellText(this.presellType)}开始还剩`;
            this._leftTime = $util.countDown.doCountDown(this._currentTime, this._presellStartTime);
        }
        if(flag == 3){
            if(this._presellway == 2){ // presellway==2指需要支付定金
                this._desc = '距支付定金开始还剩';
            }else{
                this._desc = '距支付全款开始还剩';
            }
            this._leftTime = $util.countDown.doCountDown(this._currentTime, this._depositStartTime);
        }
        if(flag == 4){
            if(this._presellway == 2){  // presellway==2指需要支付定金
                this._desc = '距定金支付结束还剩';
            }else{
                this._desc = `距${this.renderPreSellText(this.presellType)}结束还剩`;
            }
            this._leftTime = $util.countDown.doCountDown(this._currentTime, this._depositEndTime);
        }
        // if(flag == 5){
        //     this._desc = '距预售活动结束还剩';
        //     this._leftTime = $util.countDown.doCountDown(this._currentTime, this._presellEndTime);
        // }
        // this._currentTime = this._currentTime + 1000;
    }

    tick(){ 
        const nowDate = new Date();
        this._currentTime = nowDate.getTime()+_engine._timeDiff;
        this.getLeftInfo();
        let flag = this.getTimeQuantum();
        //如果预售还未开始  
        if(flag == 1){
            return;
        }     
        window.setInterval(()=>{
            const nowDate = new Date();
            this._currentTime = nowDate.getTime()+_engine._timeDiff;
            this.getLeftInfo();
        },1000)
    }
}